import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { formatedAmount } from "../../../../../utils/helpers";
import {useFormattedAmount} from "../../../../../hooks/useFormattedAmount";
import { useLocation } from "react-router-dom";
import Button from "../../../../../components/Buttons/button";

function PillCards({ data, cost, setPopup, setState }) {
  const formatFunction = useFormattedAmount();
  const { pathname } = useLocation();
  return (
    <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
      <div className="grid grid-cols-1 md:grid-cols-2 justify-center xl:justify-between items-center gap-[12px] md:gap-[24px] lg:gap-[40px] mt-3 md:mt-4 px-3 md:px-0">
        {!pathname.includes("tasker") && (
          <div className="p-3 md:p-[24px] rounded-[12px] md:rounded-[24px] lg:rounded-[32px] bg-grey-blue-700 flex justify-between items-center sm:hidden">
            <div className="flex flex-col gap-[6px]">
              {cost !== undefined ? (
                <span className="text-primary !text-[20px]">
                  {formatFunction(cost ? cost : 0)}
                </span>
              ) : (
                <span className="text-primary !text-[20px] w-[130px]">
                  <Skeleton />
                </span>
              )}

              {cost !== undefined ? (
                <span className="text-secondary">
                  {pathname.includes("personal_dashboard")
                    ? "Your monthly cost"
                    : "Total monthly cost"}
                </span>
              ) : (
                <span className="text-secondary w-[130px]">
                  <Skeleton />
                </span>
              )}
            </div>

            <div className="flex justify-center items-center">
              <Button
                onClick={() => {
                  setPopup(true);
                  setState(11);
                }}
                fill={false}
                secondary={true}
                hoverColor={true}
              >
                History
              </Button>
            </div>
          </div>
        )}

        <div className="max-w-[100%] p-[12px] md:p-[24px] bg-[#363D50] rounded-[12px] md:rounded-[24px] lg:rounded-[32px]">
          {data.average_service_cost !== undefined && (
            <span className="text-primary !text-[18px] block">
              {formatFunction(data.average_service_cost)}
            </span>
          )}
          {data.average_service_cost === undefined && <Skeleton className="!w-[132px]" />}
          <span className="text-secondary !leading-[21px] mt-[6px]">
            Average service cost
          </span>
        </div>
        <div className="max-w-[100%] p-[12px] md:p-[24px] bg-[#363D50] rounded-[12px] md:rounded-[24px] lg:rounded-[32px]">
          {data.average_service_cost !== undefined && (
            <span className="text-primary !text-[18px] block">
              {formatFunction(data.average_employee_cost)}
            </span>
          )}
          {data.average_employee_cost === undefined && <Skeleton className="!w-[132px]" />}
          <span className="text-secondary !leading-[21px] mt-[6px]">
            Average employee cost
          </span>
        </div>
      </div>
    </SkeletonTheme>
  );
}

export default PillCards;
